
import { createAction } from 'redux-act';
import { ICreateFlowPost, ICreateFlowPostComment, ILikeFlowPost, ISeenFlowPost, IRequestFlowPosts } from '@app-types/websocket/imageflow.types';

export const imageFlowCreate = createAction<ICreateFlowPost>('Create new imageflow');
export const imageFlowDelete = createAction<number>('Create new imageflow');
export const imageFlowCommentCreate = createAction<ICreateFlowPostComment>('Create new imageflow');
export const imageFlowLike = createAction<ILikeFlowPost>('Create new imageflow');
export const imageFlowSeen = createAction<ISeenFlowPost>('Create new imageflow');
export const imageFlowRequest = createAction<IRequestFlowPosts>('Create new imageflow');



// WEBPACK FOOTER //
// ./src/services/imageflow/imageflow.actions.ts